export * from './occ-doehler-wishlist.adapter';